<template>
    <v-overlay v-if="show">
        <v-card light color="content" elevation="24" width="85vw" max-width="1080px">
            <v-card-title>수정계약서 작성 및 알림 발송</v-card-title>
            <v-card-text style="max-height:75vh;overflow-y:auto;">
                <v-row>
                    <v-col class="py-0">
                        <!-- 고객정보 -->
                        <employer v-model="document.employer" :disabled="false" />

                        <!-- 대리점정보 -->
                        <employee v-model="document.employee" :interiors="interiors" :disabled="false" />

                        <!-- 날짜정보 -->
                        <dates v-model="document" :disabled="false" />

                        <!-- 공사금액정보 -->
                        <payment-plan v-model="document.paymentPlan" :disabled="false" />
                    </v-col>
                    <v-col class="py-0">
                        <!-- 기본계약사항 -->
                        <terms-basic />
                        <!-- 특별계약사항 -->
                        <terms-special v-model="document" :readonly="false" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-row>
                    <v-spacer />
                    <v-col cols="auto">
                        <v-btn color="secondary" @click="close">취소</v-btn>
                    </v-col>
                    <v-col cols="auto" class="mr-2">
                        <v-btn color="primary" @click="save">생성</v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-overlay>
</template>
<script>
import initialDocument from "@/assets/data/initialContractDocument.json";
import viewCard from "../dumb/view-card.vue";
import Employer from "./employer.vue";
import Employee from "./employee.vue";
import Dates from "./dates.vue";
import PaymentPlan from "./payment-plan.vue";
import TermsSpecial from "./terms-special.vue";
import TermsBasic from "./terms-basic.vue";
export default {
    components: { viewCard, Employer, Employee, Dates, PaymentPlan, TermsSpecial, TermsBasic },
    props: {
        interiors: { type: Array, default: [] },
    },
    data() {
        return {
            show: false,
            document: { ...initialDocument },
        };
    },
    methods: {
        open({ _id, id, createdAt, updatedAt, eSign, documentNumber, ...document }) {
            this.show = true;
            this.document = JSON.parse(JSON.stringify(document));
        },
        close() {
            this.show = false;
        },
        save() {
            this.$emit("save", this.document);
        },
    },
};
</script>
